import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,{ref:"textField",staticClass:"phone-input",attrs:{"value":_vm.value,"error-messages":_vm.errorMessages,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"outlined":"","dense":""},on:{"input":function($event){return _vm.$emit('input', $event)},"blur":function($event){return _vm.$emit('blur')}}})}
var staticRenderFns = []

export { render, staticRenderFns }